export const styles = {
	businessProcess: {
		fontWeight: 'bold',
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: 'black',
				opacity: '23%',
			},
		},
		'& .MuiInputBase-input': {
			boxSizing: 'content-box',
			height: '100%',
		},
	},
	chip: {
		paddingX: '0.5rem',
		color: '#E2F5F8',
	},
	inputLabel: {
		color: 'black',
		opacity: '23%',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #12BBF182 51%, #12BBF182 100%)',
		marginRight: '2rem',
	},
	contentContainer: {
		rowGap: '3rem',
	},
	textBlack: {
		color: 'black',
	},
	buttonContainer: {
		flexDirection: { sm: 'row' },
	},
}
